import React from 'react'
import Helmet from 'react-helmet'
import Adsense from '../components/Adsense'
import Payments from '../components/Payments'
import PremiumKeyWarning from '../components/PremiumKeyWarning'
import SEO from '../components/SEO'

const PremiumPlans = () => {
  return (
    <>
      <SEO page="premium" />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: 'Cboxera Premium',
            description:
              'Premium link generator plan with 150GB daily bandwidth, support for 50+ file hosts, no ads, no waiting time, and unlimited streaming.',
            url: 'https://www.cboxera.com/premium/',
            brand: {
              '@type': 'Brand',
              name: 'Cboxera',
            },
            offers: {
              '@type': 'Offer',
              priceCurrency: 'USD',
              price: '13.00',
              priceValidUntil: '2027-12-31',
              availability: 'https://schema.org/InStock',
              url: 'https://www.cboxera.com/premium/',
            },
          })}
        </script>
      </Helmet>
      <PremiumKeyWarning />
      <Payments />
      <Adsense slot="6222161092" format="responsive" />
    </>
  )
}

export default PremiumPlans
